import Glide from '@glidejs/glide'
let sliders = [...document.querySelectorAll('.glide')]

sliders.forEach((slider) => {
  let glide = new Glide(slider).mount()
})
